// Course (scénario d'origine, de secours pour une action sans scénario) : l'action est posée au milieu
// du chemin, l'adversaire part du bout et la consomme une fois arrivé (voir core/chase.js).
import { createChase, advanceChase, chaseGain, chaseOutcome, isCheeseGone, hasRatReachedCheese, hasRatReachedHalfway, cheeseRatio } from '../chase.js';
import { sameCell, headingOf } from './common.js';
import { POINTS_PER_CELL } from '../../config/constants.js';

/** Champs communs (voir common.js) déduits de la poursuite. */
function view(chase, path) {
  const { ratIndex, cheeseIndex } = chase;
  const pos = path[ratIndex];
  const next = path[ratIndex - 1];
  const prev = path[ratIndex + 1];
  // Une fois à l'action, l'adversaire est dessiné à cheval sur la case précédente pour ne pas la masquer
  const eating = hasRatReachedCheese(chase) && prev;
  return {
    rival: eating ? { x: pos.x + (prev.x - pos.x) * 0.6, y: pos.y + (prev.y - pos.y) * 0.6 } : pos,
    heading: eating ? headingOf(prev, pos) : next ? headingOf(pos, next) : 0,
    trail: path.slice(ratIndex).reverse(),
    goal: cheeseRatio(chase) > 0 ? path[cheeseIndex] : null,
    goalScale: cheeseRatio(chase),
  };
}

function wrap(state, chase, path) {
  return { ...state, chase, ticks: state.ticks + 1, ...view(chase, path) };
}

export const race = {
  id: 'race',
  create({ path }) {
    const chase = createChase(path.length);
    return {
      // Le temps de la course : l'adversaire rejoint l'action (travelSteps tics), puis la consomme (autant de tics)
      chase, ticks: 0, budget: 2 * chase.travelSteps, items: [], sight: [], fog: null, ping: false, phase: null, blink: false,
      rivalBadge: null, playerBadge: null, sendPlayerTo: null, result: null, reason: null,
      ...view(chase, path),
    };
  },
  tick(state, { path }) {
    const next = wrap(state, advanceChase(state.chase), path);
    return isCheeseGone(next.chase) ? { ...next, result: 'lose', reason: 'lose' } : next;
  },
  enter(state, { path, player }) {
    if (state.result || !sameCell(player, path[state.chase.cheeseIndex])) return state;
    const result = chaseOutcome(state.chase);
    return { ...state, result, reason: result };
  },
  gain: (state) => chaseGain(state.chase) * POINTS_PER_CELL,
  isIdle: (state) => hasRatReachedHalfway(state.chase),
  hints: (state, { path }) => [
    { key: 'scenario.race.hint.goal', cell: path[state.chase.cheeseIndex] },
    { key: 'scenario.race.hint.rival', cell: path[state.chase.ratIndex] },
  ],
};
